import { React, useState, useEffect, useRef, useContext } from "react";
import PCVerModal from "../PCVerModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import PartnerSelectModal from "../common/PartnerSelectModal";
import WarehouseSelectModal from "../common/WarehouseSelectModal";
import WarehouseSectionSelectModal from "../common/WarehouseSectionSelectModal";
import noImg from "../../../img/noimg.png"
import Moment from 'moment';

let newFileID = 1;
let realFiles = [];
let tmpRealFiles = [];
let imageFile = null;
function ItemUpdateModal({ title, version, onClose, id, originRows, handleView, mainPartnerOption, itemInOutOption, typeModalOption, divisionModalOption, unitModalOption, stockCurrencyModalOption, unitCurrencyModalOption, MenuUpdateYN, MenuDeleteYN }) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [partnerRows, setPartnerRows] = useState([]);
  const [updatePartnerRows, setUpdatePartnerRows] = useState([]);
  const [partnerColumns, setPartnerColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [originFileRows, setOriginFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    item_id: 0,
    item_current_version: 0,
    item_version_seq: 0,
    item_next_version_seq: 0,
    item_max_version_seq: 0,
    item_name: '',
    item_spec: '',
    item_type: 0,
    item_division: 0,
    item_unit: 0,
    item_width: '',
    item_depth: '',
    item_height: '',
    item_stock_price_currency: 0,
    item_stock_price: 0,
    item_total_safe_stock_count: 0,
    item_monthly_usage: 0,
    item_order_package_count: 1,
    item_incoming_package_count: 1,
    item_purchase_package_count: 1,
    item_outgoing_package_count: 1,
    item_expiration_yn: 'N',
    item_expiration_type: '',
    item_save_workplace_id: null,
    item_save_workplace_name: '',
    item_save_warehouse_id: null,
    item_save_warehouse_name: '',
    item_save_section_id: null,
    item_save_section_name: '',
    item_img: '',
    item_img_sever: '',
    memo: ''
  });
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectModalOpen, setSelectModalOpen] = useState(false);
  const [selectPartnerData, setSelectPartnerData] = useState('');
  const [isSelectWarehouseModalOpen, setSelectWarehouseModalOpen] = useState(false);
  const [isSelectWarehouseSectionModalOpen, setSelectWarehouseSectionModalOpen] = useState(false);
  const [upperWarehouseId, setUpperWarehouseId] = useState(0);
  const [updateFlag, setUpdateFlag] = useState(() => {
    const userId = Number(localStorage.getItem('user_id') ?? NaN);
    const last = Array.isArray(version) && version.length > 0 ? version[version.length - 1] : undefined;
    const lastVal = (last && typeof last === 'object') ? last.value : last;
    const lastNum = Number(lastVal);
    
    return (
      MenuUpdateYN === 'Y' &&
      Array.isArray(originRows) &&
      !Number.isNaN(userId) &&
      !Number.isNaN(lastNum) &&
      originRows.some(row =>
        String(row.item_id) === String(id) &&
        Number(row.item_version_seq) === lastNum &&
        Number(row.reg_user_id) === userId
      )
    );
  });

  const handleInitSelect = () => {
    tmpRealFiles = [];
    setUpdatePartnerRows([]);
    setUpdateFileRows([]);
    handleVersionSetting(originRows[0].item_max_version_seq);
  };

  const handleVersionSetting = (currentVersion) => {
    var tmpOriginRows = originRows.filter((data) => data.item_version_seq === currentVersion);

    if (!tmpOriginRows || tmpOriginRows.length === 0) return;
    
    setInputs({
      item_id: Number(tmpOriginRows[0].item_id),
      item_current_version: Number(currentVersion),
      item_max_version_seq: Number(tmpOriginRows[0].item_max_version_seq),
      item_version_seq: Number(tmpOriginRows[0].item_version_seq),
      item_next_version_seq: Number(tmpOriginRows[0].item_version_seq)+1,
      item_name: tmpOriginRows[0].item_name,
      item_spec: tmpOriginRows[0].item_spec,
      item_type: Number(tmpOriginRows[0].item_type),
      item_division: Number(tmpOriginRows[0].item_division),
      item_unit: Number(tmpOriginRows[0].item_unit),
      item_width: Number(tmpOriginRows[0].item_width),
      item_depth: Number(tmpOriginRows[0].item_depth),
      item_height: Number(tmpOriginRows[0].item_height),
      item_stock_price_currency: Number(tmpOriginRows[0].item_stock_price_currency),
      item_stock_price: Number(tmpOriginRows[0].item_stock_price),
      item_total_safe_stock_count: Number(tmpOriginRows[0].item_total_safe_stock_count),
      item_monthly_usage: Number(tmpOriginRows[0].item_monthly_usage || 0),
      item_order_package_count: Number(tmpOriginRows[0].item_order_package_count || 1),
      item_incoming_package_count: Number(tmpOriginRows[0].item_incoming_package_count || 1),
      item_purchase_package_count: Number(tmpOriginRows[0].item_purchase_package_count || 1),
      item_outgoing_package_count: Number(tmpOriginRows[0].item_outgoing_package_count || 1),
      item_expiration_yn: tmpOriginRows[0].item_expiration_yn,
      item_expiration_type: Number(tmpOriginRows[0].item_expiration_type),
      item_img: tmpOriginRows[0].item_img,
      item_img_sever: tmpOriginRows[0].item_img_sever,
      item_save_workplace_id: tmpOriginRows[0].item_save_workplace_id,
      item_save_workplace_name: tmpOriginRows[0].item_save_workplace_name,
      item_save_warehouse_id: tmpOriginRows[0].item_save_warehouse_id,
      item_save_warehouse_name: tmpOriginRows[0].item_save_warehouse_name,
      item_save_section_id: tmpOriginRows[0].item_save_section_id,
      item_save_section_name: tmpOriginRows[0].item_save_section_name,
      memo: tmpOriginRows[0].item_memo
    });

    var partnerData = tmpOriginRows.filter((item, index) => {
      return (
        tmpOriginRows.findIndex((item2, index2) => {
          return typeof item.item_partner_seq !== 'undefined' && item.item_partner_seq === item2.item_partner_seq;
        }) === index
      );
    });

    var fileData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.item_file_id !== 'undefined' && item.item_file_id === item2.item_file_id;
        }) === index
      );
    });

    fileData = fileData.sort(function(a, b) { 
      return a.item_file_id < b.item_file_id ? -1 : a.item_file_id > b.item_file_id ? 1 : 0;
    });

    setPartnerRows(partnerData.map((item, index) => ({
      id: item.item_partner_seq,
      item_in_out_type: item.item_in_out_type,
      partner_id: item.partner_id,
      partner_name: item.partner_name,
      main_partner_yn: item.main_partner_yn,
      item_partner_price_currency: item.item_partner_price_currency,
      item_partner_price: item.item_partner_price,
      reg_user_name: item.item_partner_reg_user_name,
      reg_datetime: Moment(item.item_partner_reg_datetime).format('YYYY-MM-DD HH:mm:ss'),
      row_type: 'O',
      update_type: 'N'
    })));

    setFileRows(fileData.map((item, index) => ({
      id: item.item_file_id,
      file_name_sever: item.item_file_name_sever,
      file_size: item.item_file_size,
      file_type: item.item_file_type,
      file_extension: item.item_file_extension,
      file_name: item.item_file_name,
      file_type_name: item.item_file_type_name,
      file_size_dp: item.item_file_size_dp,
      reg_user_name: item.item_file_user_name,
      reg_datetime: Moment(item.item_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
      row_type: 'O',
      update_type: 'N'
    })));

    setOriginFileRows(fileData.map((item, index) => ({
      id: item.item_file_id,
      file_name_sever: item.item_file_name_sever,
      file_size: item.item_file_size,
      file_type: item.item_file_type,
      file_extension: item.item_file_extension,
      file_name: item.item_file_name,
      file_type_name: item.item_file_type_name,
      file_size_dp: item.item_file_size_dp,
      reg_user_name: item.item_file_user_name,
      reg_datetime: Moment(item.item_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
      row_type: 'O',
      update_type: 'N'
    })));
    
    fileData.map((item, index) => 
      newFileID = (item.item_file_id >= newFileID)?(item.item_file_id)+1:newFileID,
    )
  };

  const handleSetting = () => {
    setPartnerColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
          ((params.row.update_type === "U")? 
          <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {partnerDeleteClick(params)}} label="Delete" />
          : (params.row.row_type === "A" && params.row.update_type === "N")? 
          <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {partnerAddClick(params)}} label="Add"  /> 
          :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {partnerDeleteClick(params)}} label="Delete" />)
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'item_in_out_type', headerName: '거래처유형', type: 'singleSelect', width: 100, 
        valueOptions: () => itemInOutOption ?? [], valueFormmatter: ({  value }) => 
          itemInOutOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'partner_id', headerName: 'partner_id', headerAlign: 'center', align:'center' },
      { field: 'partner_name', headerName: '거래처명', width: 180, headerAlign: 'center', align:'center' },
      { field: 'main_partner_yn', headerName: '주요거래처여부', type: 'singleSelect', width: 120, 
        valueOptions: () => mainPartnerOption ?? [], valueFormmatter: ({  value }) => 
          mainPartnerOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'item_partner_price_currency', headerName: '통화', type: 'singleSelect', width: 100, 
        valueOptions: () => unitCurrencyModalOption ?? [], valueFormmatter: ({  value }) => 
          unitCurrencyModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'item_partner_price', headerName: '단가', width: 120, headerAlign: 'center', type: 'number', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setFileColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {fileAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setPartnerColumnVisibilityModel({
      id: false,
      actions: updateFlag,
      item_in_out_type: true,
      partner_id: false,
      partner_name: true,
      main_partner_yn: true,
      item_partner_price_currency: true,
      item_partner_price: true,
      row_type: false,
      update_type: false
    });
    
    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: updateFlag,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [partnerColumnVisibilityModel, setPartnerColumnVisibilityModel] = useState({
    id: false,
    actions: updateFlag,
    item_in_out_type: true,
    partner_id: false,
    partner_name: true,
    main_partner_yn: true,
    item_partner_price_currency: true,
    item_partner_price: true,
    row_type: false,
    update_type: false
  });

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: updateFlag,
    download: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    realFiles = [];
    tmpRealFiles = [];
    handleSetting();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  useEffect(() => {
    handleInitSelect();
  }, [originRows]);
  
  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<partnerRows.length; i++){
      if(partnerRows[i].row_type === 'A' && partnerRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }

    if(ADD_YN === 'Y' && updateFlag){
      setPartnerRows((partnerRows) => [...partnerRows, { 
        id: Number(appStore.getMaxListID(partnerRows))+1,
        item_in_out_type: 0,
        partner_id: '',
        partner_name: '',
        main_partner_yn: 'N',
        item_partner_price_currency: 0,
        item_partner_price: 0,
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [partnerRows]);

  useEffect(() => {
    var array = [];
    for(var i=0; i<originFileRows.length; i++){
      var tmp_id = originFileRows[i].id;
      var tmp_file_name_sever = originFileRows[i].file_name_sever;
      var tmp_file_name = originFileRows[i].file_name;
      var tmp_file_size = originFileRows[i].file_size;
      var tmp_file_size_dp = originFileRows[i].file_size_dp;
      var tmp_file_type = originFileRows[i].file_type;
      var tmp_file_type_name  = originFileRows[i].file_type_name;
      var tmp_file_extension = originFileRows[i].file_extension;
      var tmp_file_reg_user_name = originFileRows[i].reg_user_name;
      var tmp_file_reg_datetime = originFileRows[i].reg_datetime;

      var tmpYN = 'N'
      for(var j=0; j<fileRows.length; j++){
        //origin에는 있고 file에는 없으면 -> O / D
        if(fileRows[j].id === originFileRows[i].id && fileRows[j].file_name_sever === originFileRows[i].file_name_sever && fileRows[j].reg_user_name === originFileRows[i].reg_user_name && fileRows[j].reg_datetime === originFileRows[i].reg_datetime){
          tmpYN = 'Y'
        }
      }

      if(tmpYN === 'N'){
        array.push({
          id: tmp_id,
          file_name_sever: tmp_file_name_sever,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: tmp_file_reg_user_name,
          reg_datetime: tmp_file_reg_datetime,
          row_type:'O',
          update_type: 'D'
        })
      }
    }

    for(var i=0; i<fileRows.length; i++){
      var tmp_id = fileRows[i].id;
      var tmp_file_name_sever = fileRows[i].file_name_sever;
      var tmp_file_size = fileRows[i].file_size;
      var tmp_file_type = fileRows[i].file_type;
      var tmp_file_extension = fileRows[i].file_extension;
      var tmp_file_name = fileRows[i].file_name;
      var tmp_file_type_name = fileRows[i].file_type_name;
      var tmp_file_size_dp = fileRows[i].file_size_dp;
      var tmp_reg_user_name = fileRows[i].reg_user_name;
      var tmp_reg_datetime = fileRows[i].reg_datetime;
      var tmp_row_type = fileRows[i].row_type;
      var tmp_update_type = fileRows[i].update_type;
      
      var tmpYN = 'N'
      for(var j=0; j<originFileRows.length; j++){
        if(originFileRows[j].id === fileRows[i].id && originFileRows[j].file_name_sever === fileRows[i].file_name_sever && originFileRows[j].reg_user_name === fileRows[i].reg_user_name && originFileRows[j].reg_datetime === fileRows[i].reg_datetime){
          tmpYN = 'Y'
        }
      }

      if(tmpYN === 'N'){
        if(tmp_row_type !== 'A' || tmp_update_type !== 'N'){ // 신규Row(A, N)는 제외함.
          array.push({
            id: tmp_id,
            file_name_sever: tmp_file_name_sever,
            file_size: tmp_file_size,
            file_type: tmp_file_type,
            file_extension: tmp_file_extension,
            file_type_name: tmp_file_type_name,
            file_name: tmp_file_name,
            file_size_dp: tmp_file_size_dp,
            reg_user_name: tmp_file_reg_user_name,
            reg_datetime: tmp_file_reg_datetime,
            row_type:'A',
            update_type: 'U'
          })
        }
      }
    }
    setUpdateFileRows(array);
    
    let ADD_YN = 'Y'
    for(let i=0; i<fileRows.length; i++){
      if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N' && i === (fileRows.length-1)){
        ADD_YN = 'N'
      }else if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N'){
        setFileRows((fileRows) => fileRows.filter((data) => data.id !== fileRows[i].id));
        ADD_YN = 'N'
      }
    }
    
    if(ADD_YN === 'Y' && updateFlag){
      newFileID = Number(newFileID) + 1;
      setFileRows((fileRows) => [...fileRows, { 
        id: Number(newFileID),
        file_name_sever: '',
        file_size: 0,
        file_type: '',
        file_extension: '',
        file_name: '',
        file_type_name: '',
        file_size_dp: '',
        reg_user_name: '',
        reg_datetime: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [fileRows]);

  const onSelectChange = (type, value) => {
    const nextInputs = {
        ...inputs,
        [type] : value
    };
    setInputs(nextInputs);
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processPartnerRowUpdate = (newRow, oldRow) => {
    //거래처 주소 Rows Update
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우

    if(newRow.item_in_out_type !== oldRow.item_in_out_type || newRow.partner_id !== oldRow.partner_id || newRow.main_partner_yn !== oldRow.main_partner_yn || newRow.item_partner_price_currency !== oldRow.item_partner_price_currency || newRow.item_partner_price !== oldRow.item_partner_price){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_item_in_out_type = 0;
      var row_partner_id = '';
      var row_main_partner_yn = 'N';
      var row_item_partner_price_currency = 0;
      var row_item_partner_price = 0;

      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.item_in_out_type !== 0 || newRow.partner_id !== '' || newRow.main_partner_yn !== 'N' || newRow.item_partner_price_currency !== 0 || newRow.item_partner_price !== 0){
          row_item_in_out_type = newRow.item_in_out_type;
          row_partner_id = newRow.partner_id;
          row_main_partner_yn = newRow.main_partner_yn;
          row_item_partner_price_currency = newRow.item_partner_price_currency;
          row_item_partner_price = newRow.item_partner_price;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        partnerRows.map((data) => data.id === newRow.id 
          && (data.item_in_out_type !== newRow.item_in_out_type || data.partner_id !== newRow.partner_id || data.main_partner_yn !== newRow.main_partner_yn || data.item_partner_price_currency !== newRow.item_partner_price_currency || data.item_partner_price !== newRow.item_partner_price)?
          (
            row_item_in_out_type = data.item_in_out_type,
            row_partner_id = data.partner_id,
            row_main_partner_yn = data.main_partner_yn,
            row_item_partner_price_currency = data.item_partner_price_currency,
            row_item_partner_price = data.item_partner_price
          ):""
        )
      }
      
      if(row_item_in_out_type === 0 && row_partner_id === '' && row_main_partner_yn === 'N' && row_item_partner_price_currency === 0 && row_item_partner_price === 0){
        // 1. 값이 수정되지 않은 경우.
        if(updatePartnerRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updatePartnerRows.length);
          setUpdatePartnerRows(updatePartnerRows.filter((data) => data.id !== newRow.id));
          setPartnerRows(partnerRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updatePartnerRows.length; i++) {
          if(updatePartnerRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updatePartnerRows.length);
          setUpdatePartnerRows(updatePartnerRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setPartnerRows(partnerRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updatePartnerRows.length);
          setUpdatePartnerRows(prevRows => [...prevRows, newUpdateDataArray]);
          setPartnerRows(partnerRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const partnerAddClick = (object) => {
    //품목 거래처 추가 버튼
    setPartnerRows((partnerRows) => [...partnerRows, { 
      id: Number(appStore.getMaxListID(partnerRows))+1,
      item_in_out_type: 0,
      partner_id: '',
      partner_name: '',
      main_partner_yn: 'N',
      item_partner_price_currency: 0,
      item_partner_price: 0,
      row_type:'A',
      update_type: 'N'
    }]);
  };

  const partnerDeleteClick = (object) => {
    //품목 거래처 삭제 버튼
    if(object.row.row_type === 'O'){
      setUpdatePartnerRows(prevRows => [...prevRows, { 
        id: object.row.id,
        item_in_out_type: object.row.item_in_out_type,
        partner_id:object.row.partner_id,
        partner_name: object.row.partner_name,
        main_partner_yn: object.row.main_partner_yn,
        item_partner_price_currency: object.row.iitem_partner_price_currencyd,
        item_partner_price: object.row.item_partner_price,
        row_type:'O',
        update_type: 'D'
      }]);
    }else{
      setUpdatePartnerRows((updatePartnerRows) => updatePartnerRows.filter((data) => data.id !== object.row.id));
    }
    setPartnerRows((partnerRows) => partnerRows.filter((data) => data.id !== object.row.id));
  };

  const fileAddClick = (object) => {
    const input=document.createElement('input');
    input.type="file";
    input.multiple = true;
    input.click();
    input.onchange = () => {
      tmpRealFiles = []; // 수정은 초기화용과 업로드용을 따로 둔다.
      for(var i=0; i<input.files.length; i++){
        realFiles.push(input.files[i]);
        tmpRealFiles.push(input.files[i]);
      }

      var array = [];
      for(var i=0; i<tmpRealFiles.length; i++){
        var tmp_sever_file_name = tmpRealFiles[i].name;
        var tmp_file_name = tmpRealFiles[i].name;
        var tmp_file_size = tmpRealFiles[i].size;
        var tmp_file_size_dp = appStore.convertFileSize(tmpRealFiles[i].size);
        var tmp_file_type = tmpRealFiles[i].type;
        var tmp_file_type_name  = appStore.convertFileTypeName(tmpRealFiles[i].type);
        var tmp_file_extension = tmp_sever_file_name.substring(tmp_sever_file_name.lastIndexOf('.')+1, tmp_sever_file_name.length);
        
        newFileID = Number(newFileID) + 1;
        array.push({
          id: Number(newFileID),
          file_name_sever: tmp_sever_file_name,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: '',
          reg_datetime: '',
          row_type:'A',
          update_type: 'U'
        });
      }
      setFileRows((fileRows) => [...fileRows, ...array]);
    };
  };

  const fileDeleteClick = (object) => {
    //파일 삭제 버튼
    for(let i = 0; i < realFiles.length; i++) {
      if (realFiles[i].name === object.row.file_name_sever) {
        realFiles.splice(i, 1);
        break;
      }
    }

    if(object.row.row_type === 'O'){
      setUpdateFileRows(prevRows => prevRows.some(r => r.id === object.row.id && r.update_type === 'D') ? prevRows : [...prevRows, { 
        id: object.row.id,
        file_name_sever: object.row.item_file_name_sever,
        file_size: object.row.item_file_size,
        file_type: object.row.item_file_type,
        file_extension: object.row.item_file_extension,
        file_name: object.row.item_file_name,
        file_type_name: object.row.item_file_type_name,
        file_size_dp: object.row.item_file_size_dp,
        reg_user_name: object.row.item_file_user_name,
        reg_datetime: Moment(object.row.item_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
        row_type: 'O',
        update_type: 'D'
       }]);
    }else{
      setUpdateFileRows((updateFileRows) => updateFileRows.filter((data) => data.id !== object.row.id));
    }
    
    setFileRows((fileRows) => fileRows.filter((data) => data.id !== object.row.id));
  };

  const fileDownloadClick = (object) => {
    //파일 다운로드
    axios.post('/api/SaveCommon/FileDownload', new URLSearchParams({
      fileName: object.row.file_name,
      fileNameSever: object.row.file_name_sever
    }),
    { withCredentials: true, responseType: 'blob' })
    .then(function (response) {
        if(response.status === 200){
          const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", object.row.file_name);
					document.body.appendChild(link);
					link.click();
        }else{
          appStore.capture();
        }
    })
    .catch(function (error) {
        appStore.capture();
        console.log("네트워크 실패", error);
    })
  };

  const handleOnCellClick = (params) => {
    if(params.field === 'partner_name'){
      if(params.row.item_in_out_type === 0){
        Swal.fire({
          title: '<p style="color:red">거래처 선택 오류</p>',
          text: '거래처 유형을 먼저 선택해야 합니다.',
          confirmButtonText: '확인'
        });
      } else {
        setSelectModalTitle('거래처 목록')
        setSelectModalOpen(true);
        setSelectPartnerData({
          id : params.row.id,
          item_in_out_type: params.row.item_in_out_type,
          partner_id: params.row.partner_id,
          partner_name: params.row.partner_name,
          main_partner_yn: params.row.main_partner_yn,
          item_partner_price_currency: params.row.item_partner_price_currency,
          item_partner_price: params.row.item_partner_price,
          reg_user_name: params.row.reg_user_name,
          reg_datetime: params.row.reg_datetime,
          row_type: params.row.row_type,
          update_type: params.row.update_type
        })
      }
    }
  };
  
  const handlePartnerClick = (object) => {
    //거래처목록 모달에서 클릭한 값으로 품목 거래처 데이터 설정함.
    var doubleYN = 'N'
    for(let i = 0; i < partnerRows.length; i++){
      if(partnerRows[i].partner_id === object.id && selectPartnerData.id !== partnerRows[i].id && object.id !== '' && partnerRows[i].item_in_out_type === selectPartnerData.item_in_out_type){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">거래처 중복 오류</p>',
        text: '이미 추가된 거래처 유형 및 거래처이므로, 중복으로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectPartnerData.partner_id){
        processPartnerRowUpdate(
          {
            id : selectPartnerData.id,
            item_in_out_type: selectPartnerData.item_in_out_type,
            partner_id: object.id,
            partner_name: object.partner_name,
            main_partner_yn: selectPartnerData.main_partner_yn,
            item_partner_price_currency: selectPartnerData.item_partner_price_currency,
            item_partner_price: selectPartnerData.item_partner_price,
            reg_user_name: selectPartnerData.reg_user_name,
            reg_datetime: selectPartnerData.reg_datetime,
            row_type: selectPartnerData.row_type,
            update_type: selectPartnerData.update_type
          },
          {
            id : selectPartnerData.id,
            item_in_out_type: selectPartnerData.item_in_out_type,
            partner_id: selectPartnerData.partner_id,
            partner_name: selectPartnerData.partner_name,
            main_partner_yn: selectPartnerData.main_partner_yn,
            item_partner_price_currency: selectPartnerData.item_partner_price_currency,
            item_partner_price: selectPartnerData.item_partner_price,
            reg_user_name: selectPartnerData.reg_user_name,
            reg_datetime: selectPartnerData.reg_datetime,
            row_type: selectPartnerData.row_type,
            update_type: selectPartnerData.update_type
          }
        )
      }
    }
  };

  const handleClickWarehouse = () => {
    setSelectModalTitle('창고 목록');
    setSelectWarehouseModalOpen(true);
  };

  const handleWarehouseClick = (object) => {

    const nextInputs = {
      ...inputs,
      ['item_save_workplace_id'] : object.workplace_id,
      ['item_save_workplace_name'] : object.workplace_name,
      ['item_save_warehouse_id'] : object.id,
      ['item_save_warehouse_name'] : object.warehouse_name,
      ['item_save_section_id'] : null,
      ['item_save_section_name'] : ''
    };
    setInputs(nextInputs);

    if(object.section_cnt !== 0){ // 하위 section 정보가 있을 경우 section modal 켜줌
      setSelectModalTitle('구역 목록');
      setUpperWarehouseId(object.id);
      setSelectWarehouseSectionModalOpen(true);
    }
  };

  const handleWarehouseSectionClick = (object) => {
    const nextInputs = {
      ...inputs,
      ['item_save_section_id'] : object.id,
      ['item_save_section_name'] : object.section_name
    };
    setInputs(nextInputs);
  };

  const handleImageDelete = () => {
    const nextInputs = {
      ...inputs,
      ['item_img'] : '',
      ['item_img_sever'] : ''
    };
    setInputs(nextInputs);
    document.getElementById('item_image').src = noImg;
  };
  
  const handleImage = () => {
    const input=document.createElement('input');
    input.type="file";
    input.accept="image/png, image/jpeg, image/gif";
    input.click();
    input.onchange = () => {
      var reader = new FileReader();
      reader.onload = function(e) {
        document.getElementById('item_image').src = e.target.result;
      };
      reader.readAsDataURL(input.files[0]);
      imageFile = input.files[0];
    };
  };

  const handleSave = (event) => {
    let msg = '';
    if((inputs.item_name).trim() === ''){
      msg = '품목명은 필수 입력 값 입니다.'
    }else if(inputs.item_type === 0){
      msg = '유형은 필수 선택 입니다.'
    }else if(inputs.item_division === 0){
      msg = '분류는 필수 선택 입니다.'
    }else if(inputs.item_unit === 0){
      msg = '단위는 필수 선택 입니다.'
    }
    
    if(updatePartnerRows.length > 0 && msg === ''){
      for(let i = 0; i < partnerRows.length; i++) {
        const partner_id = partnerRows[i].partner_id;
        const partner_name = (partnerRows[i].partner_name).trim();
        const item_in_out_type = partnerRows[i].item_in_out_type;
        for(let j = i+1; j < partnerRows.length; j++) {
          if(partner_id === partnerRows[j].partner_id && partner_id !== '' && item_in_out_type === partnerRows[j].item_in_out_type && item_in_out_type !== 0) {
            msg = '중복된 거래처+거래처유형이 존재합니다.<br/>[중복된 거래처 : '+partner_name+']';
            break;
          }
        }

        if(msg !== '')  {
          break;
        }
      }

      for(let i = 0; i < updatePartnerRows.length; i++) {
        const partner_id = updatePartnerRows[i].partner_id;
        const item_in_out_type = updatePartnerRows[i].item_in_out_type;
        if(partner_id === 0 || partner_id === '') {
          msg = '선택되지 않는 거래처가 존재합니다.';
          break;
        }
        if(item_in_out_type === 0 || item_in_out_type === '') {
          msg = '선택되지 않는 거래처유형이 존재합니다.';
          break;
        }
      }
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">품목 수정 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);

      axios.post("/api/p/Item/Reg", {inputs, updatePartnerRows} ,
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){
          var selectID = inputs.item_id;
          
          if(imageFile !== null){
            const formData = new FormData();
            formData.append('selectID', selectID);
            formData.append('folder', 'Item');
            formData.append('imageFile', imageFile);
            
            axios.post('/api/SaveCommon/FileImageSave'
                , formData
                , { headers: { 'Content-Type': 'multipart/form-data' } 
            });
          }

          if(updateFileRows.length > 0) {

            const formData = new FormData();
            formData.append('selectID', selectID);
            formData.append('folder', 'Item');
            formData.append('type', 'Update');
            formData.append('updateFileRows', JSON.stringify(updateFileRows));
            
            for(var i=0; i<realFiles.length; i++){            
              formData.append('files', realFiles[i]);
            }
            
            axios.post('/api/SaveCommon/GridFileSave'
                , formData
                , { headers: { 'Content-Type': 'multipart/form-data' } 
            }).then(response => {
              Swal.fire({
                title: '품목 수정 완료',
                text: '정상적으로 품목이 수정 되었습니다.',
                confirmButtonText: '확인',
                timer:5000,
                timerProgressBar: true
              }).then((result) => {
                handleView();
              });
            }).catch(error => {
              appStore.capture();
            });

          }else{

            Swal.fire({
              title: '품목 수정 완료',
              text: '정상적으로 품목이 수정 되었습니다.',
              confirmButtonText: '확인',
              timer:5000,
              timerProgressBar: true
            }).then((result) => {
              handleView();
            });
          }
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
        appStore.capture();
      })
      .finally(() => {
        appStore.setLoading(false); 
      });
    }
  };

  const versionSetup = (currentVersion) => {
    if(currentVersion > 0){
      const nextInputs = {
        ...inputs,
        ['item_current_version'] : currentVersion
      };
      setInputs(nextInputs);
      handleVersionSetting(currentVersion);
    }
  }
  
  return (
    <PCVerModal onClose={onClose} title={title} version={version} versionSetup={versionSetup}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="품목 정보" value="1" />
                <Tab label="품목 거래처" value="2" />
                <Tab label="품목 파일" value="3" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">품목명<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="품목명" value={inputs.item_name} name="item_name" onChange={(e) => onChange(e) } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD" rowSpan={4} style={ { padding: '0px' } }>
                      <div style={ { width: '440px', height: '250px', marginTop: '10px', textAlign: 'center' } }>
                        
                        {(inputs.item_img_sever === '')?
                        <><img id="item_image" src={noImg} style={{ width: '300px', height: '200px', margin: '0px' }}></img></>
                        :
                        <><img id="item_image" src={'/files/'+inputs.item_img_sever} style={{ width: '300px', height: '200px', margin: '0px' }}></img></>}
                        <div style={{textAlign: 'center'}}>
                          <Button 
                            onClick={handleImage}
                            className="btn-p btn-u"
                            style={{width : '150px'}}
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "#b317b3", 
                                backgroundColor: "#b317b3",
                                ":hover": { boxShadow: "2px 2px 2px #b317b3" , backgroundColor: "#b317b3", borderColor: "#b317b3"}
                            }} 
                            variant="outlined">
                            이미지 업로드
                          </Button>
                          <Button 
                            onClick={handleImageDelete}
                            className="btn-p btn-u"
                            style={{width : '30px'}}
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "red", 
                                backgroundColor: "red",
                                ":hover": { boxShadow: "2px 2px 2px red" , backgroundColor: "red", borderColor: "red"}
                            }} 
                            variant="outlined">
                            삭제
                          </Button>
                          </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">유형<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <Select className="modal_filed_input_select" placeholder="유형" value={typeModalOption.filter(function (option) { return option.value === inputs.item_type;  })} onChange={(e) => onSelectChange('item_type',e.value)} options={typeModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">분류<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <Select className="modal_filed_input_select" placeholder="분류" value={divisionModalOption.filter(function (option) { return option.value === inputs.item_division;  })} onChange={(e) => onSelectChange('item_division',e.value)} options={divisionModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">단위<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <Select className="modal_filed_input_select" placeholder="단위" value={unitModalOption.filter(function (option) { return option.value === inputs.item_unit;  })} onChange={(e) => onSelectChange('item_unit',e.value)} options={unitModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">재고평가금액</div>
                        <div className="modal_filed_input" style={{ display: 'flex', width: '230px' }}>
                          <Select className="modal_filed_input_select" placeholder="통화" value={stockCurrencyModalOption.filter(function (option) { return option.value === inputs.item_stock_price_currency;  })} onChange={(e) => onSelectChange('item_stock_price_currency',e.value)} options={stockCurrencyModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <input type="number" placeholder="금액" style={ { width: '90px', textAlign:'right' } } value={inputs.item_stock_price} name="item_stock_price" onChange={(e) => onChange(e) } autoComplete="off" />
                        </div>
                        <div className="modal_filed_title" style={ { paddingLeft: '30px', width: '87px' } }>보관장소</div>
                        <div className="modal_filed_input" style={ { display: 'flex' } }>
                          <input type="text" placeholder="사업장" value={inputs.item_save_workplace_name} name="item_save_workplace_name" onChange={(e) => onChange(e) } on style={{ cursor: 'pointer', float: 'left', width: '120px', marginRight: '10px' }} onClick={()=> { handleClickWarehouse() }} readOnly autoComplete="off" />
                          <input type="text" placeholder="창고" value={inputs.item_save_warehouse_name} name="item_save_warehouse_name" onChange={(e) => onChange(e) } style={{ cursor: 'pointer', float: 'left', width: '120px', marginRight: '10px' }} onClick={()=> { handleClickWarehouse() }} readOnly autoComplete="off" />
                          <input type="text" placeholder="구역" value={inputs.item_save_section_name} name="item_save_section_name" onChange={(e) => onChange(e) } style={{ cursor: 'pointer', float: 'left', width: '120px'}} readOnly autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">규격</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="규격" value={inputs.item_spec} name="item_spec" onChange={(e) => onChange(e) } style={{width: '755px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  {Number(localStorage.getItem('company_id')) === 5 ? (
                    <tr>
                      <td className="ModalTD" colSpan={2}>
                        <div className="modal_filed">
                          <div className="modal_filed_title"></div>
                          <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                            <div className="modal_filed_title" style={ { width: '71.5px', paddingLeft: '5px', paddingRight: '5px'} }>1달재고</div>
                            <input type="number" placeholder="1달재고" value={inputs.item_monthly_usage} name="item_monthly_usage" onChange={(e) => onChange(e) } style={{width: '85px', textAlign: 'right', marginRight: '15px'}} autoComplete="off" />
                            <div className="modal_filed_title" style={ { width: '71.5px', paddingLeft: '5px', paddingRight: '5px'} }>안전재고</div>
                            <input type="number" placeholder="안전재고" value={inputs.item_total_safe_stock_count} name="item_total_safe_stock_count" onChange={(e) => onChange(e) } style={{width: '85px', textAlign: 'right'}} autoComplete="off" />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td className="ModalTD" colSpan={2}>
                        <div className="modal_filed">
                          <div className="modal_filed_title"></div>
                          <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                            <div className="modal_filed_title" style={ { width: '100px', paddingRight: '5px' } }>가로</div>
                            <input type="number" placeholder="가로" value={inputs.item_width} name="item_width" onChange={(e) => onChange(e) } style={{ float: 'left', width: '85px', marginRight: '10px' }} autoComplete="off" />
                            <div className="modal_filed_title" style={ { width: '100px', paddingLeft: '5px', paddingRight: '5px'} }>세로</div>
                            <input type="number" placeholder="세로" value={inputs.item_depth} name="item_depth" onChange={(e) => onChange(e) } style={{ float: 'left', width: '85px', marginRight: '10px' }} autoComplete="off" />
                            <div className="modal_filed_title" style={ { width: '100px', paddingLeft: '5px', paddingRight: '5px'} }>높이</div>
                            <input type="number" placeholder="높이" value={inputs.item_height} name="item_height" onChange={(e) => onChange(e) } style={{ float: 'left', width: '85px', marginRight: '10px'}} autoComplete="off" />
                            <div className="modal_filed_title" style={ { width: '100px', paddingLeft: '5px', paddingRight: '5px'} }>안전재고</div>
                            <input type="number" placeholder="안전재고" value={inputs.item_total_safe_stock_count} name="item_total_safe_stock_count" onChange={(e) => onChange(e) } style={{width: '85px', textAlign: 'right'}} autoComplete="off" />
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">포장비율</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                        <div className="modal_filed_title" style={ { width: '80px', paddingRight: '5px' } }>수주</div>
                          <input type="number" placeholder="수주" value={inputs.item_order_package_count} name="item_order_package_count" onChange={(e) => onChange(e) } style={{ float: 'left', width: '85px', marginRight: '10px' }} autoComplete="off" />
                        <div className="modal_filed_title" style={ { width: '80px', paddingLeft: '5px', paddingRight: '5px'} }>출하</div>
                          <input type="number" placeholder="출하" value={inputs.item_outgoing_package_count} name="item_outgoing_package_count" onChange={(e) => onChange(e) } style={{ float: 'left', width: '85px', marginRight: '10px' }} autoComplete="off" />
                        <div className="modal_filed_title" style={ { width: '80px', paddingLeft: '5px', paddingRight: '5px'} }>발주</div>
                          <input type="number" placeholder="발주" value={inputs.item_purchase_package_count} name="item_purchase_package_count" onChange={(e) => onChange(e) } style={{ float: 'left', width: '85px', marginRight: '10px'}} autoComplete="off" />
                        <div className="modal_filed_title" style={ { width: '80px', paddingLeft: '5px', paddingRight: '5px'} }>입고</div>
                          <input type="number" placeholder="입고" value={inputs.item_incoming_package_count} name="item_incoming_package_count" onChange={(e) => onChange(e) } style={{width: '85px', textAlign: 'right'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">비고</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="비고" value={inputs.memo} name="memo" onChange={(e) => onChange(e) } style={{width: '755px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={partnerRows}
                  columns={partnerColumns}
                  columnVisibilityModel={partnerColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processPartnerRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell'
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18,  
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                    {(updateFlag && inputs.item_max_version_seq === inputs.item_current_version)?
                    <div className="modal_button">
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        수정
                      </Button>
                    </div>
                    : <></> }
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {isSelectModalOpen && (<PartnerSelectModal
          onClose={() => {
              setSelectModalOpen(false);
          }}
          title={selectmodalTitle}
          handlePartnerClick={handlePartnerClick}
        />)}
        {isSelectWarehouseModalOpen && (<WarehouseSelectModal
          onClose={() => {
              setSelectWarehouseModalOpen(false);
          }}
          title={selectmodalTitle}
          handleWarehouseClick={handleWarehouseClick}
        />)}
        {isSelectWarehouseSectionModalOpen && (<WarehouseSectionSelectModal
          onClose={() => {
              setSelectWarehouseSectionModalOpen(false);
          }}
          title={selectmodalTitle}
          upperWarehouseId={upperWarehouseId}
          handleWarehouseSectionClick={handleWarehouseSectionClick}
        />)}
    </PCVerModal>
  );
}

export default ItemUpdateModal;